import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { TextField } from 'redux-form-material-ui';
import MuiActionVisibility from 'material-ui/svg-icons/action/visibility';
import { mountainMeadows, blueGray30 } from '../../theme/colors';
import InputIconDecorator from '../input-icon-decorator';

class PasswordField extends Component {
  state = { visible: false }

  toggleVisibility = () => {
    this.setState({ visible: !this.state.visible });
  }

  render() {
    return (
      <InputIconDecorator
        iconVisible={ true }
        iconColor={ this.state.visible ? mountainMeadows : blueGray30 }
        inputIcon={ MuiActionVisibility }
        onClick={ this.toggleVisibility }
      >
        <Field
          name="password"
          component={ TextField }
          className="password-field"
          hintText="Enter your password"
          floatingLabelText="Password *"
          type={ this.state.visible ? 'text' : 'password' }
          fullWidth={ true }
          autoComplete="new-password"
          autoCapitalize="off"
          autoCorrect="off"
          validate={ this.props.validate }
          onFocus={ this.props.onFocus }
        />
      </InputIconDecorator>
    );
  }
}

PasswordField.propTypes = {
  validate: PropTypes.func,
  onFocus: PropTypes.func
};

export default PasswordField;
